import { render, staticRenderFns } from "./ImageTemplate.vue?vue&type=template&id=5b1aba78&scoped=true"
import script from "./ImageTemplate.vue.ts?vue&type=script&lang=ts&external"
export * from "./ImageTemplate.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./ImageTemplate.vue?vue&type=style&index=0&id=5b1aba78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1aba78",
  null
  
)

export default component.exports